import { Directive, HostBinding, HostListener, Input } from '@angular/core';

import { UploadEventsService } from '../upload-events-service/upload-events-service';
import { ValidDataTypes } from '../uploaders.interfaces';

@Directive({ selector: '[bmFileUploadDraggable]' })
/**
 * Make an element a draggable target
 */
export class FileUploadDraggableDirective {
  @Input() public disabled!: boolean;
  @Input() public dataType!: ValidDataTypes;

  @HostBinding('class.drag-hover')
  public dragHover!: boolean;

  constructor(private _uploadEventsService: UploadEventsService) {}

  @HostListener('dragover', ['$event'])
  public ondragover(event: DragEvent) {
    if (!this.disabled) {
      event.preventDefault();
      this.dragHover = true;
    }
  }

  @HostListener('dragleave')
  public ondragleave() {
    this.dragHover = false;
  }

  @HostListener('drop', ['$event'])
  public ondrop(event: DragEvent) {
    const { dataTransfer } = event;
    if (!this.disabled && dataTransfer) {
      dataTransfer.dropEffect = 'copy';
      this._uploadEventsService.readFiles(dataTransfer.files, this.dataType);

      event.preventDefault();
    }
  }
}
